document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('nellaFinanceDrawer');
  if (!drawer) return;

  // ✅ Match your working logic: form is found globally by ID first (because it may WRAP the drawer)
  const leasingForm =
    document.getElementById('leasing_contact_form') ||
    drawer.closest('form') ||
    document.querySelector('form#leasing_contact_form');

  if (!leasingForm) return;

  // ✅ Inputs live inside the drawer
  const nameInput  = document.getElementById('LeasingContactFormName')
                  || drawer.querySelector('#LeasingContactFormName')
                  || leasingForm.querySelector('input[name="contact[name]"]');

  const emailInput = document.getElementById('LeasingContactFormEmail')
                  || drawer.querySelector('#LeasingContactFormEmail')
                  || leasingForm.querySelector('input[name="contact[email]"]');

  const phoneInput = document.getElementById('LeasingContactFormPhone')
                  || drawer.querySelector('#LeasingContactFormPhone')
                  || leasingForm.querySelector('input[name="contact[phone]"]');

  const submitBtn  = document.getElementById('contactSubmitBtn')
                  || drawer.querySelector('#contactSubmitBtn')
                  || leasingForm.querySelector('button[type="submit"]');

  // ✅ Use your actual scroller
  const getScroller = () =>
    drawer.querySelector('.nella-drawer-scrollable-content') ||
    drawer.querySelector('.offcanvas-body') ||
    drawer;

  const scrollTop = () => {
    const scroller = getScroller();
    requestAnimationFrame(() => {
      try {
        if (scroller && typeof scroller.scrollTo === 'function') scroller.scrollTo({ top: 0, left: 0 });
        else if (scroller) scroller.scrollTop = 0;
      } catch (_) {
        if (scroller) scroller.scrollTop = 0;
      }
    });
  };

  // -------------------------------------------------------
  // ✅ Title fit (copied from your other working drawer JS)
  // -------------------------------------------------------
  const headerEl = drawer.querySelector('.offcanvas-header');
  const titleEl  = drawer.querySelector('.offcanvas-title');
  const closeEl  = drawer.querySelector('.btn-close');

  let defaultFontPx = null;
  let lastFitKey = '';

  function captureDefaultsOnce() {
    if (!titleEl || defaultFontPx !== null) return;
    const cs = window.getComputedStyle(titleEl);
    defaultFontPx = parseFloat(cs.fontSize) || 16;
  }

  function resetTitleToCssDefaults() {
    if (!titleEl) return;
    titleEl.style.removeProperty('font-size');
    titleEl.style.removeProperty('letter-spacing');
  }

  function fitTitleToHeaderWidth() {
    if (!headerEl || !titleEl) return;

    captureDefaultsOnce();

    const headerRect = headerEl.getBoundingClientRect();
    const headerW = Math.round(headerRect.width);
    if (!headerW) return;

    const csHeader = window.getComputedStyle(headerEl);
    const padL = parseFloat(csHeader.paddingLeft) || 0;
    const padR = parseFloat(csHeader.paddingRight) || 0;
    const closeW = closeEl ? Math.ceil(closeEl.getBoundingClientRect().width) : 44;

    const key = `${headerW}:${padL}:${padR}:${closeW}`;
    if (key === lastFitKey) return;
    lastFitKey = key;

    const available = headerW - padL - padR;
    if (available <= 0) return;

    resetTitleToCssDefaults();

    const fits = () => titleEl.scrollWidth <= titleEl.clientWidth + 1;
    if (fits()) return;

    const csTitle = window.getComputedStyle(titleEl);
    const baseLS = (csTitle.letterSpacing === 'normal') ? 0 : (parseFloat(csTitle.letterSpacing) || 0);
    let fontPx = parseFloat(csTitle.fontSize) || defaultFontPx || 16;

    const MIN_FONT_PX = 12.5;
    const MIN_LS_PX = -0.8;

    let steps = 0;
    while (!fits() && steps < 24 && fontPx > MIN_FONT_PX) {
      fontPx -= 0.5;
      titleEl.style.fontSize = `${fontPx}px`;

      if (!fits()) {
        const nextLS = Math.max(MIN_LS_PX, baseLS - (0.1 * (steps + 1)));
        titleEl.style.letterSpacing = `${nextLS}px`;
      }
      steps++;
    }
  }

  function runTitleFitIfOpen() {
    // only measure when open/visible
    if (!drawer.classList.contains('show')) return;
    requestAnimationFrame(() => requestAnimationFrame(fitTitleToHeaderWidth));
  }

  // fonts can load after DOMContentLoaded
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(runTitleFitIfOpen).catch(() => {});
  }

  if (window.ResizeObserver && headerEl) {
    const ro = new ResizeObserver(() => runTitleFitIfOpen());
    ro.observe(headerEl);
  } else {
    window.addEventListener('resize', () => runTitleFitIfOpen());
    window.addEventListener('orientationchange', () => setTimeout(runTitleFitIfOpen, 100));
  }

  // -------------------------------------------------------
  // Tooltip helpers (Bootstrap tooltip if available)
  // -------------------------------------------------------
  function showFieldTooltip(el, msg) {
    if (!el) return;
    el.setAttribute('title', msg);

    try {
      if (window.bootstrap && bootstrap.Tooltip) {
        el.setAttribute('data-bs-toggle', 'tooltip');
        el.setAttribute('data-bs-title', msg);

        const inst = bootstrap.Tooltip.getInstance(el) || new bootstrap.Tooltip(el, {
          trigger: 'manual',
          placement: 'top',
          container: 'body'
        });

        try { inst.setContent({ '.tooltip-inner': msg }); } catch (_) {}
        inst.show();
      }
    } catch (_) {}
  }

  function hideFieldTooltip(el) {
    if (!el) return;
    try {
      if (window.bootstrap && bootstrap.Tooltip) {
        const inst = bootstrap.Tooltip.getInstance(el);
        inst?.hide();
        inst?.dispose();
      }
    } catch (_) {}

    el.removeAttribute('data-bs-toggle');
    el.removeAttribute('data-bs-title');
    el.removeAttribute('title');
  }

  function markInvalid(el, msg) {
    if (!el) return;
    el.classList.add('is-invalid');
    showFieldTooltip(el, msg);
  }

  function clearInvalid(el) {
    if (!el) return;
    el.classList.remove('is-invalid');
    hideFieldTooltip(el);
  }

  // -------------------------------------------------------
  // Validation helpers
  // -------------------------------------------------------
  function isValidEmail(val) {
    const v = String(val || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function normalizePhoneExtensionFormat() {
    if (!phoneInput) return;
    phoneInput.value = phoneInput.value
      .replace(/\s*(ext\.?|x|#)\s*/i, ' x')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isValidPhoneWithExtension(val) {
    const raw = String(val || '').trim();
    const main = raw.replace(/\s*(?:ext\.?|x|#)\s*\d+\s*$/i, '');
    const digits = main.replace(/\D/g, '');
    if (digits.length === 10) return true;
    if (digits.length === 11 && digits.startsWith('1')) return true;
    return false;
  }

  // -------------------------------------------------------
  // Disable native browser validation UI ONLY for email + phone
  // -------------------------------------------------------
  const native = { email: null, phone: null };

  function storeNativeOnce() {
    if (emailInput && !native.email) {
      native.email = {
        type: emailInput.getAttribute('type'),
        required: emailInput.hasAttribute('required'),
        pattern: emailInput.getAttribute('pattern'),
        inputmode: emailInput.getAttribute('inputmode')
      };
    }
    if (phoneInput && !native.phone) {
      native.phone = {
        type: phoneInput.getAttribute('type'),
        required: phoneInput.hasAttribute('required'),
        pattern: phoneInput.getAttribute('pattern'),
        inputmode: phoneInput.getAttribute('inputmode')
      };
    }
  }

  function disableNativeEmailPhoneBubbles() {
    storeNativeOnce();

    if (emailInput) {
      emailInput.removeAttribute('required');
      emailInput.removeAttribute('pattern');
      emailInput.setAttribute('type', 'text');
      emailInput.setAttribute('inputmode', 'email');
    }

    if (phoneInput) {
      phoneInput.removeAttribute('required');
      phoneInput.removeAttribute('pattern');
      phoneInput.setAttribute('type', 'text');
      phoneInput.setAttribute('inputmode', 'tel');
    }
  }

  function restoreNativeEmailPhone() {
    if (emailInput && native.email) {
      const c = native.email;
      c.required ? emailInput.setAttribute('required', 'required') : emailInput.removeAttribute('required');
      c.pattern != null ? emailInput.setAttribute('pattern', c.pattern) : emailInput.removeAttribute('pattern');
      c.type ? emailInput.setAttribute('type', c.type) : emailInput.removeAttribute('type');
      c.inputmode ? emailInput.setAttribute('inputmode', c.inputmode) : emailInput.removeAttribute('inputmode');
    }

    if (phoneInput && native.phone) {
      const c = native.phone;
      c.required ? phoneInput.setAttribute('required', 'required') : phoneInput.removeAttribute('required');
      c.pattern != null ? phoneInput.setAttribute('pattern', c.pattern) : phoneInput.removeAttribute('pattern');
      c.type ? phoneInput.setAttribute('type', c.type) : phoneInput.removeAttribute('type');
      c.inputmode ? phoneInput.setAttribute('inputmode', c.inputmode) : phoneInput.removeAttribute('inputmode');
    }
  }

  [nameInput, emailInput, phoneInput].forEach((el) => {
    el?.addEventListener('input', () => clearInvalid(el));
    el?.addEventListener('blur', () => {
      if (el === phoneInput) normalizePhoneExtensionFormat();
    });
  });

  // -------------------------------------------------------
  // ✅ Body class toggles (hides chat via your CSS)
  // -------------------------------------------------------
  function setDrawerOpenState(isOpen) {
    if (isOpen) {
      document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    } else {
      document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    }
  }

  // -------------------------------------------------------
  // Offcanvas lifecycle
  // -------------------------------------------------------
  drawer.addEventListener('shown.bs.offcanvas', () => {
    setDrawerOpenState(true);
    scrollTop();
    runTitleFitIfOpen(); // ✅ title fit when visible
  });

  drawer.addEventListener('hidden.bs.offcanvas', () => {
    setDrawerOpenState(false);
    [nameInput, emailInput, phoneInput].forEach(clearInvalid);
    restoreNativeEmailPhone();

    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
    }
  });

  // -------------------------------------------------------
  // Submit handling
  // -------------------------------------------------------
  leasingForm.addEventListener('submit', (e) => {
    disableNativeEmailPhoneBubbles();

    if (!leasingForm.checkValidity()) {
      restoreNativeEmailPhone();
      return;
    }

    let ok = true;

    if (emailInput) {
      clearInvalid(emailInput);
      const v = emailInput.value.trim();
      if (!v) { markInvalid(emailInput, 'Please enter your email.'); ok = false; }
      else if (!isValidEmail(v)) { markInvalid(emailInput, 'Enter a valid email (example: name@domain.com).'); ok = false; }
    }

    if (phoneInput) {
      clearInvalid(phoneInput);
      normalizePhoneExtensionFormat();
      const v = phoneInput.value.trim();
      if (!v) { markInvalid(phoneInput, 'Please enter your phone number.'); ok = false; }
      else if (!isValidPhoneWithExtension(v)) {
        markInvalid(phoneInput, 'Enter 10 digits (extensions allowed like x123).');
        ok = false;
      }
    }

    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      scrollTop();
      (drawer.querySelector('.is-invalid'))?.focus?.();
      restoreNativeEmailPhone();
      return;
    }

    // ✅ Flag for post-redirect reopen (same as your working logic)
    try { sessionStorage.setItem('submittedContactFormId', 'leasing_contact_form'); } catch (_) {}

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    restoreNativeEmailPhone();
  });

  // -------------------------------------------------------
  // ✅ Auto-open drawer + show success/errors (retries + pageshow)
  // -------------------------------------------------------
  function openDrawerReliable() {
    let saved = null;
    try { saved = sessionStorage.getItem('submittedContactFormId'); } catch (_) {}
    if (saved !== 'leasing_contact_form') return;

    let tries = 0;
    const maxTries = 25;

    const attempt = () => {
      tries++;

      if (!window.bootstrap?.Offcanvas) {
        if (tries < maxTries) return setTimeout(attempt, 75);
        return; // don't clear the flag if we never opened
      }

      try {
        bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
      } catch (_) {}

      // When we programmatically open, make sure chat hides even if shown event is delayed
      setDrawerOpenState(true);

      scrollTop();
      runTitleFitIfOpen(); // ✅ fit title after programmatic open

      // ✅ success/errors are inside the drawer markup
      drawer.querySelectorAll('[data-contact-success],[data-contact-errors]')
        .forEach(el => el.removeAttribute('hidden'));

      try { sessionStorage.removeItem('submittedContactFormId'); } catch (_) {}
    };

    attempt();
  }

  openDrawerReliable();
  window.addEventListener('pageshow', openDrawerReliable);

  // -------------------------------------------------------
  // ✅ Safety: if theme closes drawer without firing Bootstrap events,
  // ensure body class is cleaned up when drawer loses "show"
  // -------------------------------------------------------
  const mo = new MutationObserver(() => {
    const isOpen = drawer.classList.contains('show');
    setDrawerOpenState(isOpen);
    if (isOpen) runTitleFitIfOpen();
  });
  mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
});
